import { TGetDepositItem } from './interfaces';

export const getDepositItem: TGetDepositItem = ({
  t,
  openDepositModal,
  permissions,
  selectedHostsIds,
}) => {
  return !permissions?.has('payment_create')
    ? null
    : {
        key: 'deposit',
        text: t('host.ctx.deposit'),
        iconName: 'WalletIcon',
        onClick: (host) => openDepositModal(host),
        disabled: ({ user, locked }) => {
          return (
            !user ||
            locked ||
            selectedHostsIds?.length === 0 ||
            !!(selectedHostsIds && selectedHostsIds?.length > 1)
          );
        },
      };
};
